// import node module libraries
import React, { Fragment, useEffect, useState } from 'react';
import { Alert, Row, Col, Offcanvas } from 'react-bootstrap';
import {
    ExclamationCircleFill,
    CheckCircleFill,
    ExclamationTriangleFill,
    InfoCircleFill
} from 'react-bootstrap-icons';

export const handleShowNotification = (setNotification, variant, title, message) => {
    setNotification({ variant, title, message, show: true });
};

const Notification = ({ variant, title, message, show, setNotification }) => {
    useEffect(() => {
        if (show) {
            const timerDuration = variant === 'danger' ? 6500 : 5000;
            const timer = setTimeout(() => {
                handleCloseNotification();
            }, timerDuration);
            return () => clearTimeout(timer);
        }
    }, [show, setNotification, variant]);

    const handleCloseNotification = () => setNotification({ variant: '', title: '', message: '', show: false });

    // Determine text color class based on variant
    const getTextColorClass = () => {
        if (variant === 'success' || variant === 'warning') {
            return 'text-dark';
        }
        return 'text-white';
    };

    return (
        <Fragment>
            <Row>
                <Col xl={{ offset: 3, span: 6 }} lg={{ offset: 2, span: 8 }} md={12}>
                    <Offcanvas
                        className={`bg-${variant} border-0 align-items-center ${getTextColorClass()}`}
                        show={show}
                        onHide={handleCloseNotification}
                        placement='top'
                    >
                        <Offcanvas.Header>
                            <Alert variant="" className={`d-flex align-items-start ${getTextColorClass()}`}>
                                <div className="d-flex align-items-start mt-2 me-2">
                                    {variant === 'info' && <InfoCircleFill size={28} className="me-2" />}
                                    {variant === 'success' && <CheckCircleFill size={28} className="me-2" />}
                                    {variant === 'warning' && <ExclamationTriangleFill size={28} className="me-2" />}
                                    {variant === 'danger' && <ExclamationCircleFill size={28} className="me-2" />}
                                    
                                </div>
                                <div className="mt-0">
                                    <Alert.Heading as="h1" >
                                        {title}
                                    </Alert.Heading>
                                    {message}
                                </div>
                            </Alert>
                        </Offcanvas.Header>
                    </Offcanvas>
                </Col>
            </Row>
        </Fragment>
    );
};

export default Notification;